import { IFormTypesGroup } from "../../model/formconfiguration/FormTypesGroup";
import { IFormTypesGroupCategoryService } from "../../service/formconfiguration/FormTypesGroupCategoryService";

export default class CreateFormTypesGroupsInteractor {
  private formTypesGroupCategoryService: IFormTypesGroupCategoryService;

  constructor(formTypesGroupCategoryService) {
    this.formTypesGroupCategoryService = formTypesGroupCategoryService;
  }

  async execute(formTypesGroups: IFormTypesGroup[]) {
    await this.formTypesGroupCategoryService.createFormTypesGroups(
      formTypesGroups
    );
  }
}
